import { gql } from '@apollo/client'
import { BOUNDING_BOXES_FRAGMENT } from './BoundingBoxesFragment'
import { WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT } from './WhiteRabbitProductFragment'

export const DISPLAY_AUDIT_IMAGE_FRAGMENT = gql`
  fragment DisplayAuditImage on DisplayAuditImage {
    id
    url
    boundingBoxSet {
      ...BoundingBoxes
    }
    products {
      ...WhiteRabbitSimpleProduct
    }
    flagged {
      level
      reason
      reasonType
      moreInfo
      flaggedBy {
        email
      }
      levelRaisedBy {
        email
        firstName
        lastName
      }
      date
    }
    protectedBoxes {
      id
    }
  }
  ${BOUNDING_BOXES_FRAGMENT}
  ${WHITE_RABBIT_SIMPLE_PRODUCT_FRAGMENT}
`
